export default __webpack_public_path__ + "static/media/people_search.656a19a9.png";